import { useQuery } from '@tanstack/react-query';

import { useRequest } from '@frontend/api';
import type { QueryFunction } from '@frontend/api/src/common/queryFunction';

import { getPartsPerStockMutationKey } from './keys';
import type {
  PartsPerStockQueryKey,
  PartsPerStockRequestBody,
  PartsPerStockResponseBody,
} from './types';

export const useCalculatePartsPerStock: QueryFunction<
  PartsPerStockResponseBody,
  [PartsPerStockRequestBody],
  PartsPerStockQueryKey
> = (params, { requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);

  return useQuery({
    ...queryOptions,
    queryKey: getPartsPerStockMutationKey(params),
    queryFn: ({ signal }) =>
      request('/materials/parts_per_stock_piece', {
        init: {
          signal,
          method: 'POST',
          body: params,
        },
      }),
  });
};
